import React, { Component } from "react";

class ErrorBoundaryGeneric extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error.toString());
    console.error(errorInfo.componentStack.toString());
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h1>Internal error</h1>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundaryGeneric;
